import React, { useMemo } from 'react';
import { ActivityHistoryCard } from '@europrocurement/flexy-components';
import { useTheme } from '@mui/material';
import { addNoteIcon } from '@europrocurement/l2d-icons';
import ActivitiesCardContent from '../ActivitiesCardContent/ActivitiesCardContent';
import useActivitiesHook from '../../../hooks/useActivitiesHook';

interface DossierNotesTabProps {
    noteMemo?: boolean;
    showLogData?: boolean;
    requestLogActionLimited?: boolean;
}

const DossierNotesTab: React.FunctionComponent<DossierNotesTabProps> = function ({
    noteMemo = true,
    showLogData = true,
    requestLogActionLimited = true,
}) {
    const { palette } = useTheme();

    const { activities, activitiesLoading, handleAddNote, handleEditNote, handleDeleteNote } =
        useActivitiesHook({ useMemoClient: noteMemo, requestLogActionLimited });

    const noteActivities = useMemo(() => activities.filter((a) => a.type === 'note'), [activities]);

    const actions = useMemo(
        () => [
            {
                id: 'add-note',
                label: 'Ajouter une note',
                shortLabel: 'Ajouter',
                icon: addNoteIcon,
                onClick: handleAddNote,
                variant: 'text' as const,
                color: palette.grey[700],
            },
        ],
        [handleAddNote, palette.grey],
    );

    return (
        <ActivityHistoryCard actions={actions}>
            <ActivitiesCardContent
                activities={noteActivities}
                onEditNote={handleEditNote}
                onDeleteNote={handleDeleteNote}
                activitiesLoading={activitiesLoading}
                showLogData={showLogData}
                title="Notes"
            />
        </ActivityHistoryCard>
    );
};

export default DossierNotesTab;
